var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusIconAwaitingPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Awaiting Payment",
    id: "Awaiting_Payment",
    transform: "translate(-16063 4804)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    id: "Back",
    transform: "translate(16063 -4804)",
    width: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(16061.909 -4805.091)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8869",
    id: "Group_8869"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.076,23.045a.828.828,0,0,0,1.14.233,11.048,11.048,0,0,0,1.656-1.34.823.823,0,1,0-1.154-1.174,9.391,9.391,0,0,1-1.409,1.14.823.823,0,0,0-.233,1.14Z",
    "data-name": "Path 8326",
    fill: "#ffff",
    id: "Path_8326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.569,6.482a9.43,9.43,0,0,1,1.37,1.187A.8.8,0,0,0,21.1,7.7a.823.823,0,0,0,.029-1.163,11.07,11.07,0,0,0-1.61-1.395.823.823,0,0,0-.953,1.342Z",
    "data-name": "Path 8327",
    fill: "#ffff",
    id: "Path_8327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.268,18.438a10.952,10.952,0,0,0,.646-2.032.823.823,0,0,0-1.61-.343,9.3,9.3,0,0,1-.549,1.725.813.813,0,0,0,.756,1.148.823.823,0,0,0,.756-.5Z",
    "data-name": "Path 8328",
    fill: "#ffff",
    id: "Path_8328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.986,12.167a10.922,10.922,0,0,0-.577-2.053.823.823,0,1,0-1.533.6,9.29,9.29,0,0,1,.49,1.744c.112,1.022.906.675.954.666a.823.823,0,0,0,.667-.954Z",
    "data-name": "Path 8329",
    fill: "#ffff",
    id: "Path_8329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.169,25.091a11.066,11.066,0,0,0,2.12-.2.823.823,0,0,0-.316-1.615A9.35,9.35,0,0,1,3.829,14.1a9.291,9.291,0,0,1,6.6-8.932A3.009,3.009,0,1,0,10.292,3.5a10.987,10.987,0,0,0,2.877,21.591Zm.076-22.354a1.368,1.368,0,1,1-1.368,1.368,1.37,1.37,0,0,1,1.368-1.368Z",
    "data-name": "Path 8330",
    fill: "#ffff",
    id: "Path_8330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.246,20.729a.823.823,0,0,0,.823-.823v-1.04a2.585,2.585,0,0,0-.52-5.117h-.605a.939.939,0,0,1,0-1.879h2.014a.823.823,0,1,0,0-1.645h-.889V9.045a.823.823,0,1,0-1.646,0v1.233a2.585,2.585,0,0,0,.52,5.117h.605a.939.939,0,1,1,0,1.879H11.533a.823.823,0,1,0,0,1.646h.889v.988a.823.823,0,0,0,.823.823Z",
    "data-name": "Path 8331",
    fill: "#ffff",
    id: "Path_8331"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconAwaitingPayment);
export default __webpack_public_path__ + "static/media/status_icon_awaiting_payment.6141ce69516d600d0fea1c8c6bd40d52.svg";
export { ForwardRef as ReactComponent };